import { useState, useCallback } from "react";

const useInternetSpeed = () => {
  const getNavSpeed = () => {
    try {
      const conn =
        navigator.connection ||
        navigator.mozConnection ||
        navigator.webkitConnection;
      if (conn?.downlink) {
        return Number(conn.downlink).toFixed(2);
      }
    } catch (_) {}
    return "10.00";
  };

  const [speed, setSpeed] = useState(getNavSpeed);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const checkInternetSpeed = useCallback(() => {
    const s = getNavSpeed();
    setSpeed(s);
  }, []);

  return { speed, loading, error, checkInternetSpeed };
};

export default useInternetSpeed;
